<template>
    <div class="wrapper">
        <!-- 查询条件 -->
        <el-row :gutter="5">
            <el-col :xs="4" :sm="4" :md="4" :lg="3" :xl="3">
                <el-date-picker  v-model="StartDate"  type="date" style="width: 100%" placeholder="发货日期从" width="80px"></el-date-picker>
            </el-col>
            <el-col :xs="4" :sm="4" :md="4" :lg="3" :xl="3">
                <el-date-picker  v-model="EndDate"  type="date" style="width: 100%" placeholder="发货日期到"></el-date-picker>
            </el-col>
            <el-col :xs="3" :sm="3" :md="3" :lg="2" :xl="2">
               <el-button type="primary" @click="handlesearch" style="width:100%;" icon="el-icon-search">查询</el-button>
            </el-col>
            <!-- <el-col :xs="4" :sm="4" :md="4" :lg="10" :xl="10">
                &nbsp;
            </el-col> -->
            <el-col :xs="3" :sm="3" :md="3" :lg="2" :xl="2">
               <el-button type="primary" @click="Load7Days" style="width:100%;" >7天</el-button>
            </el-col>
            <el-col :xs="3" :sm="3" :md="3" :lg="2" :xl="2">
               <el-button type="primary" @click="Load30Days" style="width:100%;" >30天</el-button>
            </el-col>
            <el-col :xs="3" :sm="3" :md="3" :lg="2" :xl="2">
               <el-button type="primary" @click="Load90Days" style="width:100%;" >90天</el-button>
            </el-col>
        </el-row>

        <!-- Card Info -->
        <el-row :gutter="40">
           <el-col :span="22">
                <el-row :gutter="20">
                    <el-col :span="6">
                        <div  class="small-box bluecolor">
                            <div class="inner">
                                <h3>{{Count_C}}</h3>
                                <p>
                                    无异常
                                </p>
                            </div>
                            
                           <div class="icon">
                                <i class="ion ion-bag"></i>
                            </div>
                            <a class="small-box-footer">
                                <!-- <i class="fa fa-arrow-circle-right"></i> -->
                                &nbsp;
                            </a>
                        </div>
                    </el-col>
                    <el-col :span="6">
                        <div  class="small-box greencolor">
                            <div class="inner">
                                <h3>{{Count_N}}</h3>
                                <p>
                                    未签收
                                </p>
                            </div>
                            <div class="icon">
                                <i class="ion ion-stats-bars"></i>
                            </div>
                            <a class="small-box-footer">
                                <!-- <i class="fa fa-arrow-circle-right"></i> -->
                                &nbsp;
                            </a>
                        </div>
                    </el-col>
                    <el-col :span="6">
                        <div  class="small-box yellowcolor">
                            <div class="inner">
                                <h3>{{Count_L}}</h3>
                                <p>
                                    多货
                                </p>
                            </div>
                            <div class="icon">
                                <i class="ion ion-person-add"></i>
                            </div>
                            <a class="small-box-footer">
                                <!-- <i class="fa fa-arrow-circle-right"></i> -->
                                &nbsp;
                            </a>
                        </div>
                    </el-col>
                    <el-col :span="6">
                        <div  class="small-box orangecolor">
                            <div class="inner">
                                <h3>{{Count_M}}</h3>
                                <p>
                                    少货
                                </p>
                            </div>
                            
                            <div class="icon">
                                <i class="ion ion-pie-graph"></i>
                            </div>
                            <a class="small-box-footer">
                                <!-- <i class="fa fa-arrow-circle-right"></i> -->
                                &nbsp;
                            </a>
                        </div>
                    </el-col>
                </el-row>
           </el-col>
        </el-row>

        <!-- 件数统计 -->
        
        <el-row :gutter="20">
           <el-col :span="14">
               <el-card>
                   单量统计
                   <div id="echartContainer" style="width:100%; height:250px"></div>
               </el-card>
           </el-col>
           <el-col :span="8">
               <el-row>
                   <div class="info-box">
                        <span class="info-box-icon bg-aqua"><i class="fa fa-envelope-o"></i></span>

                        <div class="info-box-content">
                        <span class="info-box-text">总计发货</span>
                        <span class="info-box-number">{{TotalCount}}</span>
                        </div>
                        <!-- /.info-box-content -->
                    </div>

                   
               </el-row>
               <el-row>
                   <div class="info-box">
                        <span class="info-box-icon bg-green"><i class="fa fa-flag-o"></i></span>

                        <div class="info-box-content">
                        <span class="info-box-text">入仓及时率</span>
                        <span class="info-box-number">100%</span>
                        </div>
                        <!-- /.info-box-content -->
                    </div>
                   
               </el-row>
               <el-row>
                   <div class="info-box">
                    <span class="info-box-icon bg-yellow"><i class="fa fa-files-o"></i></span>

                    <div class="info-box-content">
                    <span class="info-box-text">完好入仓率</span>
                    <span class="info-box-number">{{Percent}}%</span>
                    </div>
                    <!-- /.info-box-content -->
                </div>
                  
               </el-row>
           </el-col>
       </el-row>
       
       <el-row :gutter="20">
           <el-col :span="11">
                <el-card>
                   <div id="echartContainer2" style="width:100%; height:200px"></div>
               </el-card>
           </el-col>
           <el-col :span="11">
               <el-card>
                   <div id="echartContainer1" style="width:100%; height:200px"></div>
               </el-card>
           </el-col>
       </el-row>
    </div>
</template>

<script>
import PeriodSummaryJS from './PeriodSummary.js';
export default PeriodSummaryJS;

</script>
<style scoped>
.el-row{
    margin-bottom: 10px;
}


.small-box {
    border-radius: 2px;
    position: relative;
    display: block;
    margin-bottom: 20px;
    box-shadow: 0 1px 1px rgba(0,0,0,0.1);
    color: #fff;
}
.small-box>.inner {
    padding: 10px;
}

.small-box h3, .small-box p {
    z-index: 5;
}
.small-box h3 {
    font-size: 38px;
    font-weight: bold;
    margin: 0 0 10px 0;
    white-space: nowrap;
    padding: 0;
    
}

.small-box p {
    font-size: 15px;
    margin: 0 0 10px;
}

.small-box .icon {
    -webkit-transition: all .3s linear;
    -o-transition: all .3s linear;
    transition: all .3s linear;
    position: absolute;
    top: -10px;
    right: 10px;
    z-index: 0;
    font-size: 90px;
    color: rgba(0,0,0,0.15);
}

.small-box>.small-box-footer {
    position: relative;
    text-align: center;
    padding: 3px 0;
    color: #fff;
    color: rgba(255,255,255,0.8);
    display: block;
    z-index: 10;
    background: rgba(0,0,0,0.1);
    text-decoration: none;
}

.bluecolor{
    background-color: #64b0f2;
}
.totalInfo{
    /* background-color: #6fb3e0; */
    color:#ffffff;
    height: 120px;

    background:-webkit-gradient(linear, left bottom, left top, color-stop(0, #3c8dbc), color-stop(1, #67a8ce)) !important
}

.greencolor{
    background-color: #f1b53d !important;
}

.yellowcolor{
    background-color: #3db9dc;
}

.orangecolor{
    background-color: #ff5d48;
}

.bg-yellow{
    background-color: #f39c12 !important;
    color: #fff !important;
}

.bg-green{
    background-color: #00a65a !important;
    color: #fff !important;
}
.info-box {
    display: block;
    min-height: 90px;
    background: #fff;
    width: 100%;
    box-shadow: 0 1px 1px rgba(0,0,0,0.1);
    border-radius: 2px;
    margin-bottom: 8px;
}

.bg-aqua{
    background-color: #00c0ef !important;
    color: #fff !important;
}

.info-box-icon {
    border-top-left-radius: 2px;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 2px;
    display: block;
    float: left;
    height: 90px;
    width: 90px;
    text-align: center;
    font-size: 45px;
    line-height: 90px;
    background: rgba(0,0,0,0.2);
}

.info-box-content {
    padding: 10px 0px 10px 10px;
    margin-left: 90px;
}

.info-box-text {
    text-transform: uppercase;
    display: block;
    font-size: 14px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.info-box-number {
    display: block;
    font-weight: bold;
    font-size: 24px;
    margin-top:10px;
}


</style>


// WEBPACK FOOTER //
// src/components/PeriodSummary/PeriodSummary.vue